import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import workerUrl from "pdfjs-dist/build/pdf.worker.min.js"; // correct worker import

const PDFPreview = ({ fileUrl, style, defaultScale = 0.5 }) => {
  return (
    <div className="pdfPreviewWrapper" style={style}>
      <Worker workerUrl={workerUrl}>
        <Viewer fileUrl={fileUrl} defaultScale={defaultScale} />
      </Worker>
    </div>
  );
};

export default PDFPreview;
